import React, { useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TextField, Box } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { styled } from '@mui/system'
import { formatISODate } from '../../../Utils/formatDate'

const StyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    width: `100%`,
    '& fieldset': {
      borderColor: `rgba(40, 32, 61, 0.5)`,
      borderRadius: `10px`,
    },
    '&:hover fieldset': {
      borderColor: `rgba(40, 32, 61, 0.5)`,
    },
    '&.Mui-focused fieldset': {
      borderColor: `rgba(40, 32, 61, 0.5)`,
      border: `1px solid rgba(40, 32, 61, 0.5)`,
    },
  },
  '& .MuiInputBase-input': {
    padding: `10px 16px`,
    width: `100%`,
  },
  '& .MuiInputLabel-root': {
    color: `rgba(40, 32, 61, 0.5)`,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: `rgba(40, 32, 61, 0.8)`,
  },
  '& svg': {
    color: `#19C9D1`,
  },
}))

const DatePickerComponent = ({
  label,
  value,
  onChange,
  disabled,
  bgcolor,
  minDate,
  maxDate,
  width = `180px`,
  height = `40px`,
  border = `none`,
  borderRadius = '10px',
  views = [`year`, `month`, `day`],
}) => {
  const [error, setError] = useState(null)

  const handleDateChange = (date) => {
    if (date) {
      onChange(formatISODate(date))
      setError(null)
    } else {
      onChange(``)
    }
  }

  const handleDateError = (reason) => {
    if (reason === `invalidDate`) {
      setError(`Invalid date format`)
    } else {
      setError(null)
    }
  }

  const handleInputChange = (event) => {
    const inputValue = event.target.value
    onChange(inputValue)
    setError(null)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={value}
        label={label}
        onChange={handleDateChange}
        onError={handleDateError}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        // inputFormat="yyyy-MM-dd"
        views={views}
        renderInput={(params) => (
          <Box
            bgcolor={disabled ? `rgba(0, 0, 0, 0.04)` : bgcolor}
            width={width}
            height={height}
            borderRadius={borderRadius}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: `10px`,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: border,
              },
            }}
          >
            <StyledTextField
              {...params}
              fullWidth
              error={!!error}
              helperText={error}
              onChange={handleInputChange}
              InputProps={{
                ...params.InputProps,
                style: {
                  borderRadius: `10px`, // Ensures the border radius is consistent
                },
                endAdornment: (
                  <Box
                    sx={{
                      display: `flex`,
                      alignItems: `center`,
                    }}
                  >
                    {params.InputProps.endAdornment}
                  </Box>
                ),
              }}
            />
          </Box>
        )}
      />
    </LocalizationProvider>
  )
}

export default DatePickerComponent
